<template>
  <div>
     <el-dialog title="确认出库" :visible.sync="queRenChukuVisible" :close-on-click-modal="false" width="70%"
      @close="closeQuerenchuku" center>
      <el-form ref="querenChukuFormData" label-width="120px"   :model='querenChukuForm' :inline="true">
        <el-form-item label="车牌号 :" :rules="[
            {
              required: true,
              message: '请先维护本物料单件理重',
              trigger: 'blur',
            },
          ]">
          <span style="width: 200px">{{querenChukuForm.plateNumber}}</span>
        </el-form-item>
        <el-form-item prop="zhuangcheCost" label="装车费(元)：" :rules="[
            {
              required: true,
              message: '请输入装车费',
              trigger: 'blur',
            },
          ]">
          <el-input v-number-input.float="2" v-model="querenChukuForm.zhuangcheCost" size="mini" style="width: 200px"
            placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div>
         <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <div>{{ (item.cargoControlKey).replace(/,/g, "/") }}</div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">总重量：</span>
                  <div>
                    <span style="color:red">{{ item.sumWeight }}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{ item.num }}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;" v-if="item.cargoControlKey != '不控货'">
                  <span style="margin-left:20px;" v-if='item.controlWeight == 1 || item.controlPiece == 1'>未提量：</span>
                  <div>
                    <span v-if='item.controlWeight == 1'><span style="color:red">{{ item.controlStockWeight
                    }}</span><span>
                        吨</span></span>
                    <span v-if='item.controlPiece == 1'><span> / </span><span style="color:red">{{ item.controlStockNumber
                    }}</span><span> 件</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="item.list" style="width:100%"
            highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="number" align="center" label="件数" width=""></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="理重（吨）" align="center" width="150">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                  <span v-else>{{Number(scope.row.weight).toFixed(3)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center"
              width="150">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                  <span v-else>{{Number(scope.row.weighingWeight).toFixed(3)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
            width="120"></el-table-column>
            <el-table-column prop="locationName" align="center" label="区位"></el-table-column>
            <el-table-column prop="sceneUser" align="center" label="现场人员" width=""></el-table-column>
            <el-table-column prop="waAvNumber" align="center" label="仓位可提件数" width=""></el-table-column>
            <el-table-column prop="placeOfOrigin" align="center" label="产地" width=""></el-table-column>
            <el-table-column prop="productTypeName" align="center" label="货物类型" width=""></el-table-column>
            <el-table-column prop="specification" align="center" label="规格" width=""></el-table-column>
            <el-table-column prop="model" align="center" label="材质" width=""></el-table-column>
            <!-- <el-table-column prop="model" align="center" label="出厂过磅净重(吨)"  width=""></el-table-column> -->
          </el-table>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="closeQuerenchuku">取 消</el-button>
        <el-button type="primary" :loading="querenChukuLoading" @click="querenChukuOk">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import { confirmWhOutstockZyControl } from '@/api/wms-access'
import { virtualControlBeanZy, JfgetOutstockInfoJanFaForConfirm } from '@/api/wms-stock'
export default {
  name: 'AddChukuPlan',
  data () {
    return {
      queRenChukuVisible: true,
      querenChukuLoading: false,
      querenChukuForm: {
        plateNumber: this.xuanzhongArr.outstockPlateNumber
      },
      allDataList: []
    }
  },
  props: {
    queRenChuKuVisible1: {
      type: Boolean,
      default: false
    },
    xuanzhongArr: {
      type: Object
    }
  },
  created () {
    this.$nextTick(() => {
      this.$refs.querenChukuFormData.clearValidate()
    })
    this.getOutstockInfoJanFa()
  },
  methods: {
    // 获取数据
    getOutstockInfoJanFa () {
      JfgetOutstockInfoJanFaForConfirm({
        outstockId: this.xuanzhongArr.outstockId
      }).then(res => {
        this.getData(res)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    async getData (res) {
      this.tEmptyOutstockMaster = res.tEmptyOutstockMaster
      let tEmptyOutstockSummaryList = res.mapList

      if (tEmptyOutstockSummaryList.length != 0) {
        let mapData = new Map()
        for (const item of tEmptyOutstockSummaryList) {
          let cargoControlKey = item.tEmptyOutstockSummary.cargoControlKey
          if (cargoControlKey == ',,,') {
            cargoControlKey = '总控'
          }
          item.tEmptyOutstockSummary.flag = item.flag
          let keyArr = cargoControlKey.split(',')
          console.log(item)
          if (item.flag == '理重') {
            item.tEmptyOutstockSummary.allWeight = item.tEmptyOutstockSummary.weight
          } else {
            item.tEmptyOutstockSummary.allWeight = item.tEmptyOutstockSummary.weighingWeight
          }

          if (mapData.has(cargoControlKey)) {
            let dataObj = mapData.get(cargoControlKey)
            // dataObj.sumWeight = sum
            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weighingWeight
            }
            // dataObj.sumWeight = (dataObj.sumWeight + item.tEmptyOutstockSummary.weight).toFixed(4)
            dataObj.num = dataObj.num + item.tEmptyOutstockSummary.number
            dataObj.releaseFlag = 0
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            this.$set(item.tEmptyOutstockSummary, 'whNumber', item.whNumber)
            this.$set(item.tEmptyOutstockSummary, 'whWeight', item.whWeight)
            this.$set(item.tEmptyOutstockSummary, 'waAvNumber', item.waAvNumber)
            dataObj.list.push(item.tEmptyOutstockSummary)
          } else {
            let params = {
              oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
              twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
              organizationId: this.tEmptyOutstockMaster.organizationId, // （仓储租户id  必填）
              productionPlaceName: keyArr[0], // （产地  必填）
              goodTypeName: keyArr[1], // （货物类型名称  必填
              specificationName: keyArr[2], // （规格  必填）
              materialName: keyArr[3] // （材质  必填）
            }
            let res = ''
            let isEnableObj = {}
            if (keyArr[0] != '不控货') {
              res = await virtualControlBeanZy(params)
            }
            if (res) {
              isEnableObj = JSON.parse(res)
            }
            console.log(isEnableObj, 'isEnableObj')
            let dataObj = {
              cargoControlKey: cargoControlKey,
              releaseFlag: 0,
              list: [],
              controlStockWeight: isEnableObj.controlStockWeight,
              controlStockNumber: isEnableObj.controlStockNumber,
              controlWeight: isEnableObj.controlWeight,
              controlPiece: isEnableObj.controlPiece,
              strictReminder: isEnableObj.strictReminder,
              isEnable: isEnableObj.isEnable,
              sumWeight: 0
            }
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            this.$set(item.tEmptyOutstockSummary, 'whNumber', item.whNumber)
            this.$set(item.tEmptyOutstockSummary, 'whWeight', item.whWeight)
            this.$set(item.tEmptyOutstockSummary, 'waAvNumber', item.waAvNumber)

            dataObj.list.push(item.tEmptyOutstockSummary)
            console.log(dataObj, 'dataObj11111')

            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weighingWeight
            }
            // dataObj.sumWeight = sum
            dataObj.num = item.tEmptyOutstockSummary.number
            mapData.set(cargoControlKey, dataObj)
          }
        }
        this.allDataList = Array.from(mapData.values())
        let sumWeight = this.allDataList[0].sumWeight
        this.$set(this.allDataList[0], 'sumWeight', parseFloat(Number(sumWeight).toFixed(6)))
      } else {
        this.allDataList = []
      }
      for (const item of this.allDataList) {
        item.releaseFlag = 0
        for (let i = 0; i < item.list.length; i++) {
          this.$set(item.list[i], 'jhNumber', item.list[i].number)
        }
      }
      console.log(this.allDataList, 'this.allDataList')
    },
    closeQuerenchuku () {
      this.$emit('update:queRenChuKuVisible1', false)
    },
    recursionCheck (index, type) {
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        this.confirmWhOutstock()
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      console.log(this.allDataList, 'this.allDataListqwwwww')
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          // 控件
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')

              return
            }
          }
          if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.controlStockWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量')
              return
            }
          }
          this.recursionCheck(index + 1, type)
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')

              return
            }
          }
          // let conFlag = true
          if (item.controlWeight == '1') {
            console.log('控吨')

            if (item.sumWeight > item.controlStockWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                this.recursionCheck(index + 1, type)
              }).catch(() => {
                // this.$message.info('出库操作已取消')
              })
            } else {
              this.recursionCheck(index + 1, type)
            }
          } else {
            this.recursionCheck(index + 1, type)
          }
        }
      } else {
        this.confirmWhOutstock()
      }
      // }
    },
    // 确认出库
    querenChukuOk () {
      this.recursionCheck(0)
    },
    // 接口
    confirmWhOutstock () {
      this.$refs.querenChukuFormData.validate((valid) => {
        if (valid) {
          this.querenChukuLoading = true
          confirmWhOutstockZyControl({
            outstockId: this.xuanzhongArr.outstockId,
            loadingFee: this.querenChukuForm.zhuangcheCost,
            queryList: this.allDataList
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.$parent.getOutstockMasterLists()
              this.queRenChukuVisible = false
            })
            .catch(err => {
              this.querenChukuLoading = false
              this.$message.error(err.message)
            })
        } else {
          this.querenChukuLoading = false
        }
      })
    }

  }
}
</script>

<style>

</style>
